import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

const state = {
    nonFoodTemplates: null,
};

const getters = {};

const actions = {
    async fetchNonFoodTemplates({ commit }) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query getPageTemplatesByFilter {
                        getPageTemplatesByFilter(pageTemplateFilter: {copy: false, magazineType: "nonfood22"}) {
                            pageTemplateId
                            name
                        }
                    }
                `
            });

            commit('setNonFoodTemplates', response.data.getPageTemplatesByFilter);
        } catch (error) {
            console.error('Error while fetching non food templates:', error);
        }
    },
};

const mutations = {
    setNonFoodTemplates(state, userData) {
        state.nonFoodTemplates = userData;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
